import { VStack } from "@chakra-ui/react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { DISABLED_EDIT_CLASSNAME } from "../../../../../common/constants/campaign";
import {
  CampaignRuleResp,
  CampaignSchedule,
} from "../../../../../common/types/campaign";
import CampaignQualification from "../../CampaignQualification";
import CampaignScheduleForms from "../../CampaignSchedule";
import { selectCampaign } from "../../campaignSlice";
import CommonDrawer from "../../components/CommonDrawer";
import CampaignScheduleReadonly from "./components/CampaignScheduleReadonly";
import SectionTitle from "./components/SectionTitle";

export default function CampaignScheduleSection({
  isOpen,
  onOpen,
  onClose,
  schedule,
  rule,
  readonly,
  errorText,
  onChange,
  onRuleValidityChange,
}: {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  schedule: CampaignSchedule;
  rule: CampaignRuleResp;
  readonly: boolean;
  errorText: string;
  onChange: (schedule: CampaignSchedule, rule: CampaignRuleResp) => void;
  onRuleValidityChange: (valid: boolean) => void;
}) {
  const btnRef = useRef();

  const {
    campaignDetails: {
      data: { active },
    },
    activeErrorCheck,
  } = useSelector(selectCampaign);
  return (
    <VStack alignItems="flex-start">
      <SectionTitle
        title="Schedule"
        readonly={readonly}
        btnRef={btnRef}
        onOpen={onOpen}
        active={active}
        activeErrorCheck={activeErrorCheck}
        errorText={errorText}
      />

      <CampaignScheduleReadonly data={schedule} rule={rule} />

      <CommonDrawer
        title="Schedule"
        btnRef={btnRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <VStack
          alignItems="flex-start"
          spacing="5"
          className={readonly ? DISABLED_EDIT_CLASSNAME : ""}
        >
          <CampaignScheduleForms
            data={schedule}
            onChange={(schedule) => onChange(schedule, rule)}
          />
          <CampaignQualification
            onChange={(rule) => onChange(schedule, rule)}
            data={rule}
            setRuleValid={(a) => onRuleValidityChange(a)}
          />
        </VStack>
      </CommonDrawer>
    </VStack>
  );
}
